import { fromJS } from 'immutable';
import { actions } from 'react/api/actions/routeSurveyModal';
import { v4 as uuid } from 'uuid';

const initialState = fromJS({
  isOpen: false,
  isLoading: false,
  selectedIndex: 0,
  surveysApplied: [],
  surveys: [],
  photoAlbums: {},
  entityAnswers: {},
  signatureAnswers: {},
  toasts: {}
});

export default (state = initialState, action) => {
  const routeId = (action.payload && action.payload.routeId) ? String(action.payload.routeId) : null;
  const stopId = (action.payload && action.payload.stopId) ? String(action.payload.stopId) : null;

  switch (action.type) {
    case actions.open:
      return state.setIn([routeId, stopId, 'isOpen'], true);
    case actions.close:
      return state.mergeIn([routeId, stopId], initialState);
    case actions.selectSidebarItem:
      return state.setIn([routeId, stopId, 'selectedIndex'], fromJS(action.payload.index));

    // fetch surveys
    case actions.fetchSurveys:
      return state.setIn([routeId, stopId, 'isLoading'], true);
    case actions.fetchSurveysSucceeded:
      return state.mergeIn([routeId, stopId], fromJS({
        ...action.payload,
        isLoading: false
      }));
    case actions.fetchSurveysFailed:
      return state.setIn([routeId, stopId, 'isLoading'], false);

    // toasts
    case actions.enqueueToast: {
      const key = uuid();
      return state.mergeIn([ routeId, stopId, 'toasts'], {
        [key]: {
          key,
          ...action.payload.toast
        }
      });
    }
    case actions.dequeueToast:
      return state.removeIn([routeId, stopId, 'toasts', `${action.payload.toastKey}`]);

    // fetch photo albums
    case actions.fetchPhotoAlbums:
      return state.setIn([routeId, stopId, 'photoAlbums', `${state.getIn([routeId, stopId, 'selectedIndex'], 0)}`, 'isLoading'], true);
    case actions.fetchPhotoAlbumsSucceeded:
      return state.mergeIn([routeId, stopId, 'photoAlbums', `${action.payload.selectedIndex}`], {
        isLoading: false,
        albums: action.payload.photoAlbums
      });
    case actions.fetchPhotoAlbumsFailed:
      return state.mergeIn([routeId, stopId, 'photoAlbums', `${action.payload.selectedIndex}`], {
        isLoading: false,
        hasFailed: true
      });

    // fetch entity answer
    case actions.fetchEntityAnswer:
      return state.setIn([routeId, stopId, 'entityAnswers', `${action.payload.surveyQuestion.get('uniqueId')}`, 'isLoading'], true);
    case actions.fetchEntityAnswerSucceeded:
      return state.mergeIn([routeId, stopId, 'entityAnswers', `${action.payload.surveyQuestion.get('uniqueId')}`], {
        isLoading: false,
        results: action.payload.results
      });
    case actions.fetchEntityAnswerFailed:
      return state.setIn([routeId, stopId, 'entityAnswers', `${action.payload.surveyQuestion.get('uniqueId')}`, 'isLoading'], false);

    // fetch signature answer
    case actions.fetchSignatureAnswer:
      return state.setIn([routeId, stopId, 'signatureAnswers', `${action.payload.surveyAnswerId}`, 'isLoading'], true);
    case actions.fetchSignatureAnswerSucceeded:
      return state.mergeIn([routeId, stopId, 'signatureAnswers', `${action.payload.surveyAnswerId}`], {
        isLoading: false,
        base64Image: action.payload.base64Image
      });
    case actions.fetchSignatureAnswerFailed:
      return state.setIn([routeId, stopId, 'signatureAnswers', `${action.payload.surveyAnswerId}`, 'isLoading'], false);

    default:
      return state;
  }
};
